/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface BadRequestErrorResponseContent
 */
export interface BadRequestErrorResponseContent {
    /**
     * 
     * @type {string}
     * @memberof BadRequestErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the BadRequestErrorResponseContent interface.
 */
export function instanceOfBadRequestErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function BadRequestErrorResponseContentFromJSON(json: any): BadRequestErrorResponseContent {
    return BadRequestErrorResponseContentFromJSONTyped(json, false);
}

export function BadRequestErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadRequestErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function BadRequestErrorResponseContentToJSON(value?: BadRequestErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

